var apparelSorter = require('./lib/ApparelSorter');
module.exports = apparelSorter;


// WEBPACK FOOTER //
// ./src/helpers/apparel-sorter/index.js